export default __webpack_public_path__ + "static/media/MDSBanner.a1015ceb.jpg";